import { $t } from '@/i18n';
export default {
  type: 'object',
  fields: [
    {
      id: 'attr',
      title: $t('k_1d95ad3f'),
      type: 'string',
      'uc:allowExpr': false,
      'uc:allowReset': false,
      group: $t('k_1d95ad3f'),
      ui: { type: 'PageletAttr' },
    },
    { id: 'className', type: 'string' },
  ],
};
